export enum ContainerType {
  Max = 'max',
  Standard = 'standard',
  Big = 'big',
  Dropdown = 'dropdown',
  MultiselectDropdowm = 'multiselectDropdown',
}
